import React from 'react'
import { Route, IndexRoute } from 'react-router'
import MyCoursesPage from './views/my-courses-page'
import Layout from './layout'

const Routes = (
  <Route path="my-courses" component={Layout}>
    <IndexRoute component={MyCoursesPage} />
  </Route>
)

export default Routes
